import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
  en: {
    strCommon: {
      confirm: 'confirm',
      of: 'of',
      cancel: 'cancel',
    },
    strCommonUI: {
      button: {
        signIn: 'Sign in',
        signOut: 'Sign out',
        continue: 'Continue',
        accessAccount: 'Access my account',
        updateInfo: 'Update info',
        updateDetails: 'Update details',
        updateEmail: 'Update email',
        updatePassword: 'Update password',
        save: 'Save',
        rename: 'Rename',
        delete: 'Delete',
        cancel: 'cancel',
        add: 'add',
        addPlayers: 'Add players',
        createWatchlist: 'Create watchlist',
        remove: 'remove',
        update: 'update',
        updated: 'updated',
        edit: 'edit',
        back: 'back',
        submit: 'submit',
        confirm: 'confirm',
        postScore: 'post score',
        reject: 'reject',
        accept: 'accept',
        okGotIt: 'Ok, got it',
        singles: 'Singles',
        doubles: 'Doubles',
        subscribe: 'subscribe',
        postAScore: 'Post a score',
        new: 'NEW',
        join: 'join',
        yesDelete: 'yes, delete',
        noCancel: 'no, cancel',
        close: 'close',
        done: 'done',
        clear: 'Clear',
        clearTextField: 'clear text field',
        applyFilter: 'Apply filter',
        exportCsv: 'Export to CSV',
        manage: 'Manage',
        seeError: 'see error details',
        copyToClipboard: 'Copy to clipboard',
        register: 'Sign up',
        subscribeToNewsletter: 'Subscribe to our newsletter',
      },
      link: {
        here: 'here',
        clickHere: 'Click here',
        back: 'Back',
        backTo: 'Back to {{name}}',
        myProfile: 'My profile',
        myAccount: 'My account',
        myWatchlists: 'My watchlists',
        goToWatchlists: 'Go to My watchlists',
      },
      select: {
        pleaseChoose: 'Please choose...',
      },
      form: {
        allFieldsMandatory: 'All fields are mandatory unless otherwise stated.',
        required: 'is required',
        invalid: 'is invalid',
        consent: 'Consent',
        firstName: 'Given name',
        lastName: 'Family name',
        dob: 'Date of birth',
        inputDayPlaceholder: 'dd',
        inputMonthPlaceholder: 'mm',
        inputYearPlaceholder: 'yyyy',
        sex: 'Sex',
        sexMale: 'Male',
        sexFemale: 'Female',
        nationality: 'Nationality',
        residence: 'Country of residence',
        email: 'Email',
        password: 'password',
        watchlistName: 'watchlist name',
        parentGuardianName: 'Parent or guardian full name',
        parentGuardianEmail: 'Parent or guardian email',
        personaSelect: 'What best describes your tennis involvement?',
        pleaseSpecify: 'Please specify',
        charsRemaining: '{{ count }} characters remaining',
        whereDidYouHearAboutUsSelect: 'Where did you hear about us? (Optional)',
        validationErrors: {
          minMaxChars: 'must be between {{minLength}} and {{maxLength}} characters long',
          maxChars: '{{name} must be less than {{maxLength}} characters long',
          maxCharsExceeded: 'Max number of characters exceeded',
          dobInThePast: 'Date of birth must be a past date',
          minAge: 'Minimum age is {{minAge}}',
          maxAge: 'Maximum age is {{maxAge}}',
          minAgeToRegister: 'You must be at least {{minAge}} to register for WTN',
          minAgeForService: 'You must be at least {{minAge}} to use WTN',
          minHeight: 'Min allowed height is: {{minHeightMetric}} ({{minHeightImperial}})',
          maxHeight: 'Max allowed height is: {{maxHeightMetric}} ({{maxHeightImperial}})',
          onlyAlphanumeric: 'Only alphanumeric values are allowed',
          watchlistNameRequired: 'Please add a name for the watchlist',
          watchlistNameExists: 'You already have a watchlist with this name',
          invalidValue: 'Invalid value',
        },
      },
      placeholder: {
        searchResidence: 'Type residence...',
        searchNationality: 'Type nationality...',
        personaDetails: 'Enter a role...',
        whereHeardDetails: 'Enter where you heard about us...',
        searchNationality: 'Type nationality...',
        searchNationalAssociation: 'Type National Association...',
      },
      ariaLabel: {
        accountMenu: 'Account Menu',
        pendingMatchMenu: 'Social match options menu',
        moreInfo: 'More info',
        moreOptions: 'More options',
        noRating: 'No rating available',
        watchlistIncludedBtn: 'Player included in Watchlist, click to remove player',
        watchlistNotIncludedBtn: 'Player not included in Watchlist, click to add player',
        loading: 'Loading',
      },
    },
    strAlerts: {
      managingPlayerWl: {
        error: {
          addFull: '<1>Player can’t be added</1><2/>‘{{name}}’ is full',
          addPluralFull: '<1>Player can’t be added</1><2/>{{count}} watchlists are full',
        },
      },
    },
    strMessageScreen: {
      recaptchaValidationErrorInfo:
        'reCAPTCHA could not determine with certainty that the form was submitted by a human. Please refresh this page and try again. If the issue persists <2>contact us</2>',
      featureNotAvailableReadFaqs:
        '<0>You may be ineligible for this feature. Please read our <2>FAQs</2>.</0>',
      lockedFeature: {
        logIn: '<0>Please <1>Log in</1> to your account.</0>',
        logInOrSignUp: '<0><0>Log in</0> or <2>Sign up</2> for an account.</0>',
        blurredResults: 'To view results, you will need to be logged in',
        blurredMatchHistory: 'To view match history, you will need to be logged in',
        blurredWtnHistory: 'To view history, you will need to be logged in',
      },
    },
    strFastTrackRegistration: {
      accountCreated: 'Your account has been created!',
      welcome: 'Welcome',
      features: {
        one: 'Match activity',
        two: 'Personalised GameZone',
        three: 'ITF World Tennis Number history',
      },
      checkDetails: 'Please check your details below to make sure they’re correct',
      residenceTooltip: {
        partOne:
          'Knowing your country of residence enable us to support your queries and improve your experience.',
        partTwo:
          'If you reside in several countries, please choose the one where you play tennis tournaments more often.',
      },
      residenceInfoQuestion: 'What if I reside in several countries?',
    },
    strRegister: {
      header: 'Welcome',
      subheader: 'Create your account',
      commConsentItf:
        'Yes, I would like to receive news, information, and special offers from the ITF',
      commConsentNa:
        'Yes, I would like to receive emails from my National Association for marketing purposes',
      intro:
        'Create your ITF Tennis ID user account to gain access to the <2>ITF World Tennis Number</2>.',
      introAlreadyCustomer: {
        1: 'It looks like you already have an ITF Tennis ID user account with one of the ITF’s other online services such as IPIN or ITF Academy.',
        2: 'Please press CONTINUE to sign in using your existing ITF account email and password to complete your registration for <1>ITF World Tennis Number</1>.',
      },
      infoBoxOne: 'Not {{firstName}} {{lastName}}?<1/><2>Click here</2> for what to do next',
      infoBoxTwo: 'Are your details incorrect? If so, please click <2>here</2>',
      recaptchaDisclaimer:
        'This site is protected by reCAPTCHA and the Google <2>Privacy Policy</2> and <6>Terms of Service</6> apply.',
      agreeTermsWelcome:
        'By creating an account, you agree to <2>ITF Privacy Policy</2> and <6>ITF World Tennis Number Terms & Conditions</6>',
      agreeTermsWelcomeParent:
        'By creating an account, your Parent/Guardian agrees to <2>ITF Privacy Policy</2> and <6>ITF World Tennis Number Terms & Conditions</6>',
      agreeTermsWelcomeYouAndParent:
        'By creating an account, you and/or your Parent/Guardian agree to <2>ITF Privacy Policy</2> and <6>ITF World Tennis Number Terms & Conditions</6>',
      agreeTermsActivation:
        'By activating your account, you agree to <2>ITF Privacy Policy</2> and <6>ITF World Tennis Number Terms & Conditions</6>',
      invalidResidence: {
        GBR: "Currently we're unable to register players who reside in the UK. The good news is that you are still able to find out your ITF World Tennis Number by registering or logging into your profile on the <2>LTA website</2><3/>*Please select 'Ireland' for your country of residence if you reside in Northern Ireland. This is due to Tennis Ireland's province structure.",
        FRA: "Currently we're unable to register players who reside in France. For more information on tennis in France please click <2>here</2>.<4/>Bonjour, a l'heure actuelle l'enregistrement en ligne en France n'est pas disponible. Pour plus d'informations, veuillez visiter le site de la <7>Federation francaise du tennis</7>.",
        USA: 'Players residing in the USA can create and unlock their World Tennis Number account by clicking the <1>‘CREATE WTN PROFILE’</1> link on their <4>USTA profile</4>',
      },
      whereDidYouHear: {
        NA: 'National Association (including ITF)',
        TENNIS_CLUB: 'Tennis Club',
        TENNIS_TOURNAMENT: 'Tennis Tournament',
        WORD_OF_MOUTH: 'Word of mouth',
        SOCIAL_MEDIA: 'Social media',
        SEARCH_ENGINE: 'Search engine',
        BLOG_OR_PUBLICATION: 'Blog or publication',
        OTHER: 'Other',
      },
      personas: {
        CASUAL_PLAY: 'I play casually with friends and family',

        COMPETITIVE_PLAY: 'I play competitively in tournaments and leagues',

        INTEREST_ONLY: "I don't play but I have an interest in tennis",

        COACH: 'I coach tennis',

        PARENT_OR_CARER: 'I am a parent/carer of a Juniors player',

        OTHER: 'Other',
      },
      comingSoon: {
        title: 'Registration will be available soon',
      },
      parentalConsent: {
        fastTrack: {
          title: 'Parent/Guardian',
        },
        infoBox: {
          title: 'Under 18 registrations',
          info: 'If you are under 18 years of age you must ask your parents or legal guardian’s consent before you register for an account on worldtennisnumber.com.',
        },
        helpText: 'Please provide the name and email address of your parent or legal guardian.',
      },
      residenceValidationError:
        'Something went wrong fetching country of residence data. Please try again.',
    },
    strPsq: {
      heading: 'Rate My Game',
      introMsg:
        'Complete these simple questions for us to create you an <1>ITF World Tennis Number</1> until you start competing.',
      infoBox:
        'You’ll only be able to fill this in <1>once.</1><2 /><3>You won’t be able to change</3> your answers, so please make sure you complete it correctly.',
      review: {
        title: 'Review',
        infoText: 'Please review your answers and submit when you’re ready.',
      },
      modalConfirm: {
        heading: 'Confirm answers',
        infoText:
          "You'll only be able to submit this form <1>ONCE</1>.<3></3>Please <5>confirm you're happy with the answers</5>.",
      },
      screenCompleted: {
        common: { heading: 'Your number' },
        public: {
          info1:
            'Your answers have been used to generate a <1>World Tennis Number</1> that you’ll be able to use until you start competing.',
          info2:
            'Your <1>Singles number</1> has been set as <4>{{wtnSingles}}</4><5/>Your <7>Doubles number</7> has been set as <10>{{wtnDoubles}}</10>',
          info3: 'Claim your profile and begin:',
          info4:
            '<0><1>Improving your rating</1><1>Compare your rating to your clubmates and players around the world</1><1>Track changes to your rating</1><1>Follow friends and opponents and view their results</1><1>Access all of your results in one place</1></0>',
          info5:
            'If your National Association has provided you with a WTN through past match results, this will take precedence over the WTN you have just generated.',
          button: 'Claim my profile',
        },
        registered: {
          info1: 'Thank you for answering our questions.',
          info2:
            'Your answers have been used to generate a <1>World Tennis Number</1> that you’ll be able to use until you start competing.',
          info3:
            'Your <1>Singles number</1> has been set as <4>{{wtnSingles}}</4><5/>Your <7>Doubles number</7> has been set as <10>{{wtnDoubles}}</10>',
          info4: 'Enjoy your tennis.',
          button: 'My profile page',
        },
      },
      submitErrorInfo: 'Please refresh or try again later',
      widgetMsg: 'Start competing to get your number',
      widgetText: '',
      widgetLinkText: 'Until you start playing fill in our <2>‘Rate My Game’</2> questionnaire',
      q1: { question: 'What type of matches do you usually play in?', intro: 'I play:' },
      q2: { question: 'How would you describe your skill level on court?', intro: "I'm:" },
      q3: { question: 'Are you mainly a singles or doubles player?' },
      q4: { question: 'From experience, how often do you hold serve?' },
      q5: {
        question:
          'Thinking back to when you first picked up a racket, how many years have you been playing tennis?',
      },
      q6: { question: 'What is your sex?' },
      q7: { question: 'Please enter your age' },
      q1a1: {
        review: 'I play <strong>for fun</strong> when I get the chance',
        option: '<strong>for fun</strong> when I get the chance',
      },
      q1a2: {
        review: 'I play <strong>casual matches</strong> with friends or family',
        option: '<strong>casual matches</strong> with friends or family',
      },
      q1a3: {
        review:
          'I play <strong>official matches in amateur</strong> tournaments, clubs, leagues or university/school teams',
        option:
          '<strong>official matches in amateur</strong> tournaments, clubs, leagues or university/school teams',
      },
      q1a4: {
        review: 'I play <strong>official matches in county level</strong> tournaments and leagues',
        option: '<strong>official matches in county level</strong> tournaments and leagues',
      },
      q1a5: {
        review:
          'I play <strong>official matches in regional or national</strong> tournaments or leagues',
        option: '<strong>official matches in regional or national</strong> tournaments or leagues',
      },
      q2a1: {
        review:
          "I'm <strong>just starting out</strong> as a tennis player, but would like to play more",
        option:
          '<strong>just starting out</strong> as a tennis player, but would like to play more',
      },
      q2a2: {
        review:
          "I'm <strong>still a beginner</strong> but I've played a few games and I'm gaining confidence",
        option:
          "<strong>still a beginner</strong> but I've played a few games and I'm gaining confidence",
      },
      q2a3: {
        review:
          "I'm <strong>playing regularly</strong> and improving every time I step out onto the court",
        option:
          '<strong>playing regularly</strong> and improving every time I step out onto the court',
      },
      q2a4: {
        review:
          "I'm <strong>an intermediate player.</strong>  I can read my opponent's game and have a wide selection of shots",
        option:
          "<strong>an intermediate player.</strong>  I can read my opponent's game and have a wide selection of shots",
      },
      q2a5: {
        review:
          "I'm <strong>regularly competing in arranged matches </strong> and win fairly often",
        option: '<strong>regularly competing in arranged matches </strong> and win fairly often',
      },
      q2a6: {
        review:
          "I'm <strong>regularly competing in tournaments</strong> and I generally win the matches I play",
        option:
          '<strong>regularly competing in tournaments</strong> and I generally win the matches I play',
      },
      q2a7: {
        review:
          "I'm <strong>regularly competing in competitions and tournaments, </strong>  winning my matches comfortably",
        option:
          '<strong>regularly competing in competitions and tournaments, </strong>  winning my matches comfortably',
      },
      q2a8: {
        review:
          "I'm <strong>regularly entering tournaments </strong> and am always one of the very best players on court",
        option:
          '<strong>regularly entering tournaments </strong> and am always one of the very best players on court',
      },
      q3a1: { review: "I'm a <strong>Singles</strong> player", option: '<strong>Singles</strong>' },
      q3a2: { review: "I'm a <strong>Doubles</strong> player", option: '<strong>Doubles</strong>' },
      q4a1: {
        review: "<strong>I rarely win</strong> the point when I'm serving",
        option: "<strong>I rarely win</strong> the point when I'm serving",
      },
      q4a2: {
        review: '<strong>I compete for every point</strong> but am sometimes beaten on my serve',
        option: '<strong>I compete for every point</strong> but am sometimes beaten on my serve',
      },
      q4a3: {
        review: '<strong>I win nearly all</strong> of my points when serving',
        option: '<strong>I win nearly all</strong> of my points when serving',
      },
      q4a4: { review: "I'm not too sure", option: "I'm not too sure" },
      q5a1: {
        review: "I've been playing for <strong>Less than 1</strong> year",
        option: '<strong>Less than 1</strong> year',
      },
      q5a2: {
        review: "I've been playing for <strong>1 - 2</strong> years",
        option: '<strong>1 - 2</strong> years',
      },
      q5a3: {
        review: "I've been playing for <strong>2 - 5</strong> years",
        option: '<strong>2 - 5</strong> years',
      },
      q5a4: {
        review: "I've been playing for <strong>5 - 10</strong> years",
        option: '<strong>5 - 10</strong> years',
      },
      q5a5: {
        review: "I've been playing for <strong>10 - 20</strong> years",
        option: '<strong>10 - 20</strong> years',
      },
      q5a6: {
        review: "I've been playing for <strong>More than 20 </strong> years",
        option: '<strong>More than 20 </strong> years',
      },
      q6a1: { review: "I'm <strong>male</strong>", option: '<strong>Male</strong>' },
      q6a2: { review: "I'm <strong>female</strong>", option: '<strong>Female</strong>' },
      q7a1: "I'm <strong>{{value}}</strong>",
    },
    strWatchlists: {
      watchlists: 'watchlists',
      watchlist: 'Watchlist',
      name: 'Watchlist name',
      firstName: 'First Name',
      lastName: 'Surname',
      save: 'Save',
      cancel: 'Cancel',
      noCancel: 'No, Cancel',
      yesDelete: 'Yes, Delete',
      playerWatchlistsTitle: 'Select watchlist(s)',
      defaultWatchlist: 'My watchlist',
      update: 'Update',
      add: 'Add',
      delete: 'Delete',
      rename: 'Rename',
      new: 'Create new',
      players: 'Players',
      gender: 'Gender',
      nationality: 'Nationality',
      singles: 'Singles',
      doubles: 'Doubles',
      noPlayers: 'No players in watchlist',
      deleteWatchlist: 'Delete watchlist',
      deleteWatchlistAlertStart: 'Are you sure you want to delete permanently',
      deleteWatchlistAlertEnd: 'watchlist together with players in that watchlist?',
      deletePlayerAlert: 'Are you sure you want to delete the selected player(s)?',
      limit: 'A maximum of 5 watchlists can be created.',
      watchlistOverview: {
        intro: 'You can create up to <1>{{maxWatchlists}} watchlists.</1>',
        rulesIntro: 'Each watchlist can have:',
        rule1: 'Up to <1>{{maxPlayers}} players</1>',
        rule2: 'A <1>name at your choice</1>',
        featuresIntro: 'You’ll be able to',
        feature1: 'Add players',
        feature2: 'Remove players',
        feature3: 'Delete watchlists',
      },
      watchlistDetail: {
        infoText: 'You can have up to <1>{{maxPlayers}} players</1> per watchlist.',
      },
      addPlayers: {
        title: 'Add players',
        info: '<0>You can add players to the <1>{{name}} watchlist.</1></0>',
        label: 'Search for player',
      },
      createWatchlist: {
        title: 'Create watchlist',
        infoText:
          'You can create up to {{maxWatchlists}} and add up to {{maxPlayersForWatchlist}} players to each.',
        textUnderInput: 'Max {{maxChars}} characters',
      },
      deleteWatchlistModal: {
        info: 'Are you sure you want  to delete permanently <1>‘{{name}}’</1> watchlist together with players in that watchlist?',
      },
      addOrManageModal: {
        add: {
          info: 'Add <1>{{name}}</1> to:',
        },
        manage: {
          info: 'Assign or remove <1>{{name}}</1> to/from:',
        },
      },
      addToWatchlist: {
        title: 'Add to watchlist',
        infoText: 'Choose which watchlists you want to add <2>{{name}}</2> to:',
        infoFull1:
          'You have already reached the maximum number of watchlists ({{maxWatchlists}}) and they are all full ({{maxPlayers}} players each).',
        infoFull2: 'You won’t be able to add any players until you create space.',
      },
      watchlistModal: {
        createNew: 'Create new watchlist',
      },
    },
    strPolicies: {
      heading: 'ITF World Tennis Number Privacy and Cookie Policies',
      intro: 'View our policies for',
      under18: 'under 18 years old',
      over18: 'over 18 years old',
      cookiePolicy: 'cookie policy',
    },
    strProfile: {
      h2hSearchDescription: 'Select players to compare <2>{{name}}</2> to',
      modals: {
        info: {
          competitions:
            '<0>Under the ‘Competitions’ feature, all competition match results that have been submitted by your National or Regional Association, or the ITF, will be shown here.</0><1>Note that you will be unable to submit tournament match results here.</1>',
          myMatches:
            '<0>Under the ‘My Matches’ feature, you can now post scores for the matches you played outside of tournaments.</0><2>Note that you will only be able to submit a result against a player who holds an <1>ITF World Tennis Number</1> account, however this does exclude IPIN Juniors and Professionals.</2><4>Once a score is submitted, your opponent will be sent an email asking for them to confirm the match result(s). If there is not a response within 72 hours, this will be automatically verified.</4>',
        },
      },
      sections: {
        overview: 'overview',
        results: 'results',
        h2h: 'head-to-head',
        competitions: 'competitions',
        socialMatches: 'my matches',
      },
      overview: 'Overview',
      playerStats: 'Player Stats',
      comparePlayers: 'Compare players',
      headToHead: 'Head to Head',
      wtnHistory: 'World Tennis Number history',
      playerTournMatches: 'Player tournament matches',
      resultsSummary: 'Results summary',
      pageNotFound: 'The page you requested cannot be found.',
      invalidPlayerId: 'This player ID is invalid',
      error: 'Error',
      defaultErrorMsg: 'Something went wrong...',
      problemLoadingProfile: 'Encountered an error while loading this players profile. ',
      navigateBack: 'Please navigate back to the',
      homepage: 'homepage',
      notFound: 'Player Not Found',
      selectAnotherPage: 'or select another page from the navigation menu.',
    },
    strH2H: {
      age: 'Age',
      yearOfBirth: 'Birth Year',
      gender: 'Gender',
      nationality: 'Nationality',
      wtnSingles: 'SINGLES NUMBER',
      wtnDoubles: 'DOUBLES NUMBER',
      wins: { one: 'win', other: 'wins' },
      winsWithCount: '{{count}} win',
      winsWithCount_plural: '{{count}} wins',
      winLikelihood: {
        singlesLabel: 'SINGLES WIN LIKELIHOOD',
        doublesLabel: 'DOUBLES WIN LIKELIHOOD',
        score: {
          over: 'Over {{score}}%',
          under: 'Under {{score}}%',
          exact: '{{score}}%',
        },
        unavailable: 'Prediction unavailable',
        lowConfidence:
          '<0>Both players must have verified World Tennis Numbers for an accurate prediction to display.</0> <2>Understanding verification</2>',
      },
      totalWins: 'Total wins',
      loginToView: '<0>Log in</0> to view',
    },
    strSocialMatches: {
      modals: {
        approve: {
          list: {
            1: '<0>{{ fullName }} has accepted your invitation to join <3>ITF World Tennis Number</3></0>',
          },
        },
        addPlayer: {
          shareLinkText:
            'Can’t find a player? They may not be registered or ineligible for an account. Please read our <2>FAQs</2> before inviting players.',
        },
      },
      postScore: {
        matchFormat: {
          options: {
            '3s6g': {
              helperText:
                '<0>You play up to three tie-break sets to six games – first player to win two, wins the match.</0><1>Each set must be by two clear games (e.g., 6-4) – if the score goes to 6-6, then you play a seven point tie-break to decide the winner.</1>',
            },
            '2s6g': {
              helperText:
                '<0>You play two tie-break sets to six games, with a match tie-break (up to 10 points) to decide the winner at one set all.</0><1>Each set must be by two clear games (e.g., 6-4) – if the score goes to 6-6, then you play a seven point tie-break to decide the winner.</1><2>The match tie-break is a race to 10 points but must also be won by two clear points</2>',
            },
            '2s4g': {
              helperText:
                '<0>You play two short tie-break sets to four games, with a match tie-break (up to 10 points) to decide the winner at one set all.</0><1>Each set must be by two clear games (e.g., 4-2) – if the score goes to 3-3, then you play a seven point tie-break to decide the winner.</1><2>The match tie-break is a race to 10 points but must also be won by two clear points.</2>',
            },
            '1s6g': {
              helperText:
                '<0>You play one tie-break set to six games – whoever wins, claims the match.</0><1>The set must be by two clear games (e.g., 6-4) – if the score goes to 6-6, then you play a seven point tie-break to decide the winner.</1>',
            },
            '10p': {
              helperText:
                '<0>You play first to 10 points in a tie-break format – alternating server after the first point and then every two points for the rest of the match.</0><1>You can only win by two clear points, so if the score goes to 9-9 you keep playing, e.g. you could win 18-16.</1>',
            },
          },
        },
      },
    },
    strGuidedTour: {
      competitions: {
        content:
          '<0>Under the ‘Competitions’ feature, all competition match results that have been submitted by a National or Regional Association, or the ITF, will be shown here.</0><1>Visit your profile to view your competition match results.</1><2>Note that players will be unable to submit tournament match results here.</2>',
        contentOwnProfile:
          '<0>All competition match results that have been submitted by your National or Regional Association, or the ITF, will appear in this tab.</0><1>Note that you will not be able to submit scores here.</1>',
      },
      myMatches: {
        content:
          '<0><0>NEW!</0> Players can now post scores for the matches played outside of tournaments.</0><1>Visit your profile to begin posting scores.</1><2>Note that players will only be able to submit a result against an opponent who holds an <1>ITF World Tennis Number</1> account, however this does exclude IPIN Juniors and Professionals.</2>',
        contentOwnProfile:
          '<0><0>NEW!</0> You can now post scores for the matches you played outside of tournaments.</0><1>Note that you will only be able to submit a result against a player who holds an <2>ITF World Tennis Number</2> account, however this does exclude IPIN Juniors and Professionals.</1>',
      },
    },
    strFilters: {
      genderDefaultLabel: 'Any Gender',
      male: 'Male',
      female: 'Female',
      anyGender: 'Gender',
      anyGenderOption: 'Any gender',
      nonBinary: 'Non-Binary',
      anyAgeGroup: 'Age group',
      ageGroupCompositeDropdownLabel: 'Age: %{ageGroup}',
      ageGroupBornInLabel: 'Born %{birthYear}',
      countries: 'Countries',
      yes: 'yes',
      no: 'no',
      filterBy: 'Filter by',
      countryDefaultLabel: 'Nationality',
      nationalityCompositeDropdownLabel: 'Nationality: +%{numberSelected}',
      clearFilter: 'Clear filter',
      countryFilterPlaceholder: 'Type to filter...',
      wtnRange: 'WTN Range',
      apply: 'APPLY FILTER',
      cancel: 'CANCEL',
      rangeLabel: '%{range} Rating',
      rangeLabelSingles: 'Singles number',
      rangeLabelDoubles: 'Doubles number',
      clearFilters: 'Clear filters',
      filters: 'Filters',
      minRating: 'Min rating',
      maxRating: 'Max rating',
      rating: {
        radioAllPlayers: 'All players',
        radioRatingRange: 'Rating range',
        labelDropdownCombined: 'WTN Rating',
        labelRatingType: 'Rating type',
        labelConfidenceLevel: 'Confidence level',
        labelGameZone: 'My Game zONe',
        defaultLabelSingles: 'Singles number',
        defaultLabelDoubles: 'Doubles number',
        radioSingles: 'Singles',
        radioDoubles: 'Doubles',
        radioConfidenceHigh: 'High confidence (verified)',
        radioConfidenceAll: 'All',
        compositeDropdownLabel: '{{appliedLabel}}: {{min}}-{{max}}',
        inputError: 'Allowed values are between {{max}} and {{min}} with only one decimal.',
      },
      confidenceModal: {
        title: 'Number Verification',
        subtitle: 'Your number has a verification tick, this relates to degree of confidence',
        featureConfidenceHigh: {
          title: 'Confident',
          items: {
            1: 'We have <1>lots of results</1> for you so have a better understanding of your ability',
            2: ' You can be <1>confident your Number is accurate</1>',
          },
        },
        featureConfidenceLow: {
          title: 'More data required',
          items: {
            1: 'We need <1>more recent results</1> for you in order to better understand your ability',
            2: 'Your number may <1>not be as accurate as it could be</1>',
          },
        },
        ariaLabel: {
          tickHigh: 'Blue confidence ribbon',
          tickLow: 'Grey confidence ribbon',
          exampleNumber: 'Example number',
        },
      },
      gameZoneModal: {
        title: 'Game zONe',
        register: {
          info: '<0>This feature is available to registered users only.</0>',
          button: '<0>register now</0>',
        },
        content:
          '<0>Our Game zONe identifies a range of potential opponents whose Numbers are close to yours on the scale.</0><1><0>Game zONe will find evenly-matched opponents wherever you are, to ensure the best possible experience on court</0><1>Our industry-leading algorithm analyses player performance data and millions of match results.</1></1><2>Don’t forget, as your Number changes, your Game zONe will change too, so be sure to check back regularly to find new opponents to play.</2>',
      },
    },
    strMobileFilter: {
      filters: 'Filters',
      filtersWithCount: 'Filters ({{count}})',
      filtersAndSort: 'Filters and Sort',
      filtersAndSortWithCount: 'Filters and Sort ({{count}})',
      gameType: 'Game type',
      year: 'year',
      reset: 'Reset',
      clearAll: 'Clear all',
      gender: 'Gender',
      ageGroup: 'Age group',
      anyAgeGroupOption: 'Any age group',
      nationality: 'Nationality',
      anyNationality: 'Any nationality',
      rating: 'WTN Rating',
      anyRating: 'All players',
      sortBy: 'Sort by',
      sortingLabelSingles: 'Singles number',
      sortingLabelDoubles: 'Doubles number',
      sortingLabelName: 'Player name',
      cancel: 'Cancel',
      goBack: 'Back',
      updateFilters: 'Apply Filters',
      timePeriod: 'Time period',
    },
    strProviderLink: {
      content: '<0>Data supplied by the {{providerName}}. </0>',
      landing: '<0>View details on the <2>{{providerName}} website</2>.</0>',
      support: '<0>Something not right? <2>Contact the {{providerName}}</2>.</0>',
    },
    strMyAccount: {
      myDetails: 'My details',
      changePassword: 'Change password',
      signInDetails: {
        title: 'Sign in details',
        subtitle: 'Below you’ll be able to update your sign in details.',
        bodyTitle: 'Update details',
      },
      accountUpToDate: 'Please keep your account details up to date.',
      avatar: 'Avatar',
      editAvatar: 'Edit avatar',
      uploadPhotoText: 'You can pick an ITF avatar.',
      tennisId: 'Tennis ID',
      playerProfile: 'Player profile',
      infoText: 'If you would like to update your details, please',
      infoError:
        'Sorry, an error occurred while retrieving your details. Please refresh or try again later.',
      contactUs: 'contact us',
      playerInfo: 'Player info',
      profileStrength: 'Profile Strength',
      strProfileStrength: {
        wtn: 'Get your WTN',
        avatar: 'Add an avatar',
        residence: 'Add residence',
        playerInfo: 'Complete player info',
        postMatch: 'Post a match result',
        haveResult: 'Have a match result',
      },
      completionPercentage: '{{count}}% complete',
      completeProfile: 'Complete profile',
      privacyAndConsents: {
        title: 'Privacy & consents',
        subtitle: 'Choose who can see you and manage your communication preferences.',
        bodyTitle: 'Your preferences',
        form: {
          profileVisibility: {
            alert:
              'To fully enjoy your World Tennis Number experience set your profile visibility to “Public”. Your player profile will not be searchable and your name will not be shown in match results.',
            label: 'Set your profile visibility',
            optionPublic: 'Public (recommended)',
            optionPrivate: 'Private',
          },
        },
      },
      logout: 'Logout',
    },
    strMatchHistory: {
      matchHistory: 'Match history',
      noMatchHistory: 'No match history found',
      date: 'Date',
      tournament: 'Tournament',
      draw: 'Draw',
      winner: 'Winner',
      score: 'Score',
      headToHead: 'Head-to-Head',
      percentageWins: '% wins',
      wtn: 'WTN',
      time: 'time',
      times: 'times',
      notCompeted: 'These players have not competed',
      close: 'Close',
    },
  },
}
i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })

export default i18n
